window.addEventListener('DOMContentLoaded', function () {
    new SimpleLightbox('.js-lightbox', {
        animationSlide: false
    });

    new SimpleLightbox('.js-lightbox-gallery', {
        animationSlide: true
    });
});